module.exports = __webpack_public_path__ + "img/items-grid-img.5a9a681f.png";